import '@babel/polyfill';
import Vue from 'vue';
import VueMoment from 'vue-moment';
import 'vue-popperjs/dist/vue-popper.css';

import App from './App.vue';
import Button from './components/button/Button.vue';
import CheckPermission from './components/helpers/CheckPermission.vue';
import CheckPermissionForExactEntity from './components/helpers/CheckPermissionForExactEntity.vue';
import { PublicSettings } from './enums/publicSettings.enum';
import { boolean } from './filters/boolean';
import router from './router';
import store from './store/store';
import { apm } from './utils/reportErrors';

if (process.env.VUE_APP_LOGS_SERVER) {
  Vue.use(apm as any, { router });
}

Vue.use(VueMoment as any);
Vue.filter('boolean', boolean);
Vue.component('check-permission', CheckPermission);
Vue.component('check-permission-for-exact-entity', CheckPermissionForExactEntity);
Vue.component('w-button', Button);

store.dispatch('setting/findPublic', { code: PublicSettings.FOOTER_LINKS });

if (process.env.VUE_APP_ENABLE_DEVTOOLS === 'true') {
  console.log('enable devtools');
  Vue.config.productionTip = false;
  Vue.config.devtools = true;
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
